
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M23 3.45V9h-5.55l2-2A9 9 0 003.53 9L2 7.47a11 11 0 0118.9-1.91zM12 21a9 9 0 01-7.47-4l2-2H1v5.51l2.09-2.09A11 11 0 0022 16.55L20.47 15A9 9 0 0112 21z"}})])
          )
        }
      }
    